import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function ValvulasPage() {
  useSeo({
    title: 'Válvulas Hidráulicas Industriais | Duraflow',
    description: 'Válvulas direcionais, de pressão, vazão, retenção e proporcionais para controle completo de sistemas hidráulicos industriais.',
    keywords: 'válvulas hidráulicas, válvulas direcionais, válvulas proporcionais, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/valvulas-hidraulicas',
    ogUrl: 'https://www.pilarmanutencao.com.br/valvulas-hidraulicas',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-HIDRAULICAS/CARD/VALVULAS-HIDRAULICAS.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Válvulas Hidráulicas"
      subtitle="Válvulas direcionais, reguladoras, de retenção e segurança para controle completo de pressão, vazão e direção em sistemas hidráulicos."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/VALVULAS-HIDRAULICAS/HERO/HERO-VALVULAS-HIDRAULICAS.webp"
      heroImageAlt="Válvulas hidráulicas industriais de controle de fluxo"
      description="As válvulas hidráulicas DURAFLOW regulam todos os parâmetros fundamentais de um circuito hidráulico: pressão, vazão e direção do fluxo. Oferecemos válvulas direcionais, de controle de pressão, de controle de vazão, de retenção e sequência, com acionamento manual, mecânico, hidráulico, pneumático ou elétrico."
      applications={[
        'Centrais hidráulicas de comando',
        'Sistemas de segurança de prensas',
        'Circuitos de proteção contra sobrecarga',
        'Máquinas injetoras e sopradoras',
        'Sistemas de posicionamento automático',
        'Indústria de papel, celulose e mineração',
      ]}
      types={[
        {
          title: 'Válvulas Direcionais',
          description:
            'Válvulas direcionais mono e biestáveis com 2, 3 e 4 vias, acionadas por solenoide, alavanca, pedal ou acionamento hidráulico e pilotado.',
        },
        {
          title: 'Válvulas de Pressão',
          description:
            'Válvulas redutoras, limitadoras, sequenciais, de contrabalanço e de descompressão para proteção e controle de pressão do circuito.',
        },
        {
          title: 'Válvulas de Vazão',
          description:
            'Válvulas reguladoras e divisórias de vazão para controle preciso da velocidade de atuadores e distribuição proporcional do fluxo.',
        },
        {
          title: 'Válvulas de Retenção',
          description:
            'Válvulas de retenção simples, pilotadas e hidropilotadas para bloqueio direcional do fluxo com liberação controlada quando necessário.',
        },
        {
          title: 'Válvulas Proporcionais',
          description:
            'Válvulas proporcionais e servo-proporcionais para controle contínuo e eletrônico de pressão, vazão e direção em sistemas automatizados.',
        },
        {
          title: 'Blocos e Placas Manifold',
          description:
            'Blocos manifold personalizados para montagem compacta de válvulas, reduzindo conexões, vazamentos e espaço ocupado no painel.',
        },
      ]}
      differentials={[
        'Amplo estoque de válvulas das principais bitolas e configurações de acionamento',
        'Suporte técnico para dimensionamento e seleção da válvula adequada ao circuito',
        'Válvulas compatíveis com padrões CETOP, DIN e ISO para fácil substituição',
        'Serviço de limpeza, teste e recalibração de válvulas proporcionais e servo',
        'Montagem de blocos manifold sob medida conforme circuito hidráulico do cliente',
      ]}
    />
  );
}